<div class="footer">
    <!-- <p> <small> &copy; <span><a routerLink="/.">2023</a></span> Tshwane University of Technology. All Righ<span><a routerLink="/.">ts</a></span> Reserv<span><a routerLink= "admin-login">ed.</a></span></small></p> -->
    <p> <small> &copy; <span>2025 Tshwane University of Technology. All Rightsed.</span></small></p>
</div>
